import { render, staticRenderFns } from "./SchoolCreateSchoolStats.vue?vue&type=template&id=0e2a0273&"
import script from "./SchoolCreateSchoolStats.vue?vue&type=script&lang=ts&"
export * from "./SchoolCreateSchoolStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports